import CreateIndex from './CreateIndex';
import AuthApp from '../AuthApp';

CreateIndex(<AuthApp />);
